import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { staggerContainer, staggerItem } from '../hooks/useAnimations';

const HERO_IMG = 'https://static.prod-images.emergentagent.com/jobs/7621458b-ca63-4125-ad1b-115cf548682c/images/e2bf7539380232c158edb21ac1619c8ff9791a16d08714d3b35212123f73cd7b.png';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-[#050505] pt-20 flex items-center justify-center relative overflow-hidden" data-testid="not-found-page">
      {/* Background */}
      <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-10" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/50 via-[#050505]/80 to-[#050505]" />

      <div className="relative z-10 text-center px-6 max-w-lg">
        <motion.div initial="hidden" animate="show" variants={staggerContainer}>
          <motion.p variants={staggerItem} className="text-[120px] md:text-[180px] font-bold text-zinc-900 leading-none select-none" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>
            404
          </motion.p>
          <motion.h1 variants={staggerItem}
            className="text-3xl md:text-4xl font-bold tracking-tighter text-white -mt-6 md:-mt-10" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>
            Fuera de Rango
          </motion.h1>
          <motion.p variants={staggerItem} className="text-base text-zinc-400 mt-4 max-w-sm mx-auto">
            Parece que este hoyo no existe. Regresa al campo principal.
          </motion.p>
          <motion.div variants={staggerItem} className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
            <Link to="/" className="bg-white text-black px-8 py-4 text-sm font-medium hover:bg-zinc-200 transition-colors inline-flex items-center gap-2" data-testid="404-home-btn">
              Volver al Inicio <ArrowRight size={16} />
            </Link>
            <Link to="/contacto" className="border border-white/20 text-white px-8 py-4 text-sm font-medium hover:bg-white/10 transition-colors" data-testid="404-contact-btn">
              Contactar Concierge
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}
